import { logAndTrackError } from 'utils/log/logAndTrackError'
import ResumeError from 'error/resumeError'
import { UrlParams } from 'utils/url'
import RootStore from 'stores/RootStore'
import TraversalStore from 'stores/TraversalStore'
import { StartupCommand } from './command.interface'

export class ResumeTraversalCommand implements StartupCommand {
  name = 'ResumeTraversal'
  dependencies = ['InitFcid']
  timeout = 10000

  private getResumeHash = (
    resumeParam: string | undefined,
    traversal: TraversalStore
  ) => {
    const { nextResumeHash, traversalId } = traversal

    if (nextResumeHash) {
      return nextResumeHash
    }

    if (resumeParam) {
      return resumeParam
    }

    logAndTrackError(
      new ResumeError(
        'Could not get resume hash from localStorage',
        traversalId
      )
    )

    return undefined
  }

  execute = async ({ traversal }: RootStore, urlParams: UrlParams) => {
    const resumeHash = this.getResumeHash(urlParams.resume, traversal)

    if (!resumeHash) {
      return
    }

    try {
      await traversal.resume(resumeHash)
    } catch (error) {
      logAndTrackError(error as Error)
    }
  }
}

export default ResumeTraversalCommand
